import { render, staticRenderFns } from "./AltPayPageComponent.vue?vue&type=template&id=fd0afc02&scoped=true&"
import script from "./AltPayPageComponent.vue?vue&type=script&lang=js&"
export * from "./AltPayPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./AltPayPageComponent.vue?vue&type=style&index=0&id=fd0afc02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0afc02",
  null
  
)

export default component.exports